import { Routes } from '@angular/router';
import { AuthCallbackComponent } from '../public/auth/auth-callback/auth-callback.component';
import { LoginComponent } from '../public/auth/login/login.component';
import { LoggedOutComponent } from '../public/logged-out/logged-out.component';
import { NotFoundComponent } from '../secure/components/not-found/not-found.component';
import { ForbiddenComponent } from '../secure/components/forbidden/forbidden.component';

export const publicRoutes: Routes = [
  {
    path: 'auth/callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    pathMatch: 'full',
  },
  {
    path: 'logout',
    component: LoggedOutComponent,
  },
  {
    path: 'logged-out',
    component: LoggedOutComponent,
  },
  {
    path: '404',
    component: NotFoundComponent,
    pathMatch: 'full',
  },
  {
    path: '403',
    component: ForbiddenComponent,
    pathMatch: 'full',
  },
];
